<template>
    <div class="table-responsive">
    <base-table :key="'table'+tick" class="table align-items-center table-flush table-bg"
                thead-classes="thead-light bg-white"
                tbody-classes="list"
                :data="locationDocuments">
        <template slot="columns">
            <th>Name</th>
            <th>Ausstellung am</th>
            <th>Ablauf am</th>
            <th></th>
        </template>
        <template slot-scope="{row}">
            <th v-if="isLoadingDocuments" scope="row" >
                <div class="loading"> </div>
            </th>
            <th v-else scope="row" v-html="row.name">
            </th>
            <td v-if="isLoadingDocuments" scope="row" >
                <div class="loading"> </div>
            </td>
            <td v-else scope="row">{{row.issuedAt|formatDateToDay}}
            </td>
            <td v-if="isLoadingDocuments" scope="row" >
                <div class="loading"> </div>
            </td>
            <td v-else scope="row">{{row.invalidAt|formatDateToDay}}
            </td>
            <td :key="tick">
                <div v-if="isLoadingDocuments" class="loading-button"> </div><div v-else>
                <base-button  type="primary" icon="fas fa-pencil-alt" v-on:click="editLocationDocument(row)"></base-button>
                <base-button  type="primary" icon="fas fa-eye" v-on:click="downloadFileAndShowDocumentViewer(row.document['@id'].split('s/')[1])"></base-button>
            </div>
            </td>
        </template>
    </base-table>
        <location-document-modal ref="locationdocumentmodal" :location="location" :show="showLocationDocumentModal" @modalClosed="refreshData"></location-document-modal>
    </div>
</template>

<script>

    import LocationDocumentModal from "@/views/LocationDocuments/Modal";
    export default {
        name:"list",
        components:{LocationDocumentModal},
        props: {
            location: {
                type: String
            }
        },
        data() {
            return {
                locationDocuments: [
                    {
                        location: null,
                        document: null,
                        customer: null,
                        type: null,
                        name: null,
                        description: null,
                        isFirst: null,
                        invalidAt: null,
                        issuedAt: null,
                        createdAt: null
                    }
                ],
                isLoadingDocuments: true,
                showLocationDocumentModal: {value: false},
                tick: 1
            }
        },
        created() {
            this.refreshData();
        },
        methods: {
            refreshData() {
                this.isLoadingDocuments = true;
                this.tick++
                this.getLocationDocuments(this.location).then(response => {
                    this.locationDocuments = response.member;
                    this.isLoadingDocuments = false;
                    this.tick++
                }).catch(error => {
                    this.$store.dispatch('alert/error',error);
                    this.isLoadingDocuments = false;
                    this.tick++
                })
            },
            getLocationDocuments(id) {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/location_documents?location=`+id+`&pagination=false`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve({
                                    totalItems: response['hydra:totalItems'],
                                    member: response['hydra:member']
                                });

                            },
                            error => {
                                reject(error);
                            });
                });
            },
            editLocationDocument(obj){
                this.showLocationDocumentModal.value = true;
                this.$refs.locationdocumentmodal.$refs.locationdocumentform.locationDocument = JSON.parse(JSON.stringify(obj));
                this.$refs.locationdocumentmodal.$refs.locationdocumentform.locationDocument.location = (typeof obj.location !== 'undefined') ? obj.location['@id'] : null ;
                this.$refs.locationdocumentmodal.$refs.locationdocumentform.locationDocument.document = (typeof obj.document!== 'undefined') ? obj.document['@id'] : null ;
            }
        }
    }
</script>

<style scoped>

    .table-bg {
        background-color: #ffffff;
    }

</style>